import PropTypes from 'prop-types'

import { CTA_CTE } from '../../../constants/mediosEnviosPagos.js'
import { nombreMedioPago } from '../../../helpers/mediosPago.js'
import { ChipList } from '../../components/index.js'
import styles from './MediosPagoChips.module.css'

/**
 * Lista de chips con los medios de pago de una publicación.
 * Los no habilitados se muestran con variante `warning` y el motivo en el tooltip.
 * @param {{ mediosPagos?: Array, title?: string, onSolicitarCuentaCorriente?: Function }} props
 */
export const MediosPagoChips = ({
  mediosPagos = [],
  title = 'Medios de Pago',
  onSolicitarCuentaCorriente
}) => {
  const items = mediosPagos.flatMap((mp) => {
    const label = nombreMedioPago(mp)
    if (!label) return []

    return [
      {
        id: mp.idMedioPago,
        label,
        tooltip: mp.tooltip,
        variant: mp.habilitado ? 'default' : 'warning',
        tooltipSize: 'large'
      }
    ]
  })

  const puedeSolicitarCtaCte =
    onSolicitarCuentaCorriente &&
    mediosPagos.some((mp) => mp.idMedioPago === CTA_CTE && !mp.habilitado)

  // Aunque ningún medio tenga nombre para mostrar, la solicitud de cuenta corriente sigue visible.
  if (items.length === 0 && !puedeSolicitarCtaCte) return null

  return (
    <>
      <ChipList title={title} items={items} />
      {puedeSolicitarCtaCte ? (
        <p className={styles.solicitarCtaCte}>
          <i className="fa fa-info-circle" aria-hidden="true" />
          <span>No tenés cuenta corriente con este vendedor.</span>
          <button
            type="button"
            className={styles.solicitarLink}
            onClick={onSolicitarCuentaCorriente}
          >
            Solicitarla
          </button>
        </p>
      ) : null}
    </>
  )
}

export const medioPagoPropType = PropTypes.shape({
  idMedioPago: PropTypes.number,
  habilitado: PropTypes.bool,
  tooltip: PropTypes.string,
  nombre: PropTypes.string,
  medioPago: PropTypes.shape({
    nombre: PropTypes.string
  })
})

MediosPagoChips.propTypes = {
  mediosPagos: PropTypes.arrayOf(medioPagoPropType),
  title: PropTypes.string,
  onSolicitarCuentaCorriente: PropTypes.func
}
